export default "/_next/static/images/img1-d979e5856cd59831acac27123f58551a.png";